const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeads(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFAD38"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC066"
    },
    cx: 256,
    cy: 256,
    r: 227.868
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD9A0C"
    },
    d: "M92.122,160.492c-1.549,0-3.119-0.426-4.524-1.321c-3.933-2.503-5.091-7.719-2.587-11.651 C122.508,88.617,186.429,53.451,256,53.451s133.492,35.165,170.989,94.068c2.504,3.932,1.345,9.148-2.587,11.651 c-3.932,2.505-9.147,1.345-11.651-2.587C378.369,102.573,319.77,70.33,256,70.33s-122.369,32.245-156.751,86.253 C97.641,159.11,94.911,160.492,92.122,160.492z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA7B0A"
    },
    d: "M217.401,129.407h-16.375c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h27.628 L217.401,129.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA7B0A"
    },
    d: "M310.974,129.407h-16.375l-11.253,16.879h27.628c4.661,0,8.44-3.779,8.44-8.44 S315.635,129.407,310.974,129.407z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD9A0C"
    },
    d: "M352.891,152.054c-19.995,0-36.203,16.21-36.203,36.203h-22.088v-58.851h-12.548 c-7.463,0-13.512,6.049-13.512,13.512v45.338H256h-12.538v-45.338c0-7.463-6.049-13.512-13.512-13.512h-12.548v58.851h-22.088 c0-19.994-16.21-36.203-36.203-36.203s-36.203,16.21-36.203,36.203v137.737c38.558,0,70.092-30.074,72.425-68.044 c0-0.006,1.93-0.011,1.93-0.016h19.27c0,17.825,10.457,33.044,25.199,39.127l-31.924,64.474c0,0,19.189,8.68,46.194,8.68 s46.194-8.68,46.194-8.68l-31.924-64.474c14.742-6.083,25.199-21.303,25.199-39.127h19.269c0,0.006,1.93,0.011,1.93,0.016 c2.333,37.971,33.866,68.044,72.425,68.044V188.257C389.094,168.263,372.885,152.054,352.891,152.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD9A0C"
    },
    d: "M286.945,454.423h-61.89c-4.661,0-8.44-3.779-8.44-8.44c0-4.661,3.779-8.44,8.44-8.44h61.89 c4.661,0,8.44,3.779,8.44,8.44C295.385,450.644,291.606,454.423,286.945,454.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD9A0C"
    },
    d: "M317.89,416.54H194.11c-4.661,0-8.44-3.779-8.44-8.44c0-4.661,3.779-8.44,8.44-8.44h123.78 c4.661,0,8.44,3.779,8.44,8.44C326.33,412.761,322.551,416.54,317.89,416.54z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeads);
export default __webpack_public_path__ + "static/media/heads.2d7489a51c1d6be376dd2d63d4bf4ce2.svg";
export { ForwardRef as ReactComponent };